import waitForElement, { WaitForElementOptions } from 'utils/waitForElement';

export class IFrameLoader {
  constructor(
    private readonly id: string,
    private readonly options?: WaitForElementOptions
  ) {}

  async load(): Promise<HTMLIFrameElement> {
    const iframe = await waitForElement<HTMLIFrameElement>(`#${this.id}`, this.options);

    if (!iframe) {
      throw new Error(`Iframe #${this.id} not found`);
    }

    return iframe;
  }
}
